import {ApiMarket} from '../api';

export const calculate24HourChange = (market: ApiMarket):number => {
  const open = parseFloat(market.open_24h);
  const last = parseFloat(market.last);
  const percentage = (last-open)/open * 100;
  return percentage;
}
